import { USER_STATS_ENDPOINT } from "../api-services/ApiEndpoints";

export const getUserStats = async () => {
    const url = `${process.env.REACT_APP_API_URL}${USER_STATS_ENDPOINT}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch user stats: ${response.status}`);
    }
    
    return await response.json();
};
